<div class="panel-header-container" [formGroup]="taxMaterialLaborRateFormGroup">
    <div class="panel-header-row">

        <button mat-icon-button (click)="isTaxMaterialLaborRateExpanded = !isTaxMaterialLaborRateExpanded" class="button-expand-collapse">
            <mat-icon class="icon-expand-collapse">
                {{isTaxMaterialLaborRateExpanded ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
        </button>
        <table class="full-width" [formGroup]="taxMaterialLaborRateFormGroup.controls.headerRow">
            <tr class="custom-table-row">
                <td class="estimate-table-column width-190">{{ headerRow.description.value || ('TAX_MATERIAL_LABOR_RATE' | translate) }}</td>
                <td class="estimate-table-column width-70"></td>
                <td class="estimate-table-column width-70"></td>
                <td class="estimate-table-column width-70"></td>
                <td class="estimate-table-column width-210 padding-gm"></td>
                <td class="estimate-table-column width-110"></td>
                <td class="estimate-table-column width-110">
                    {{ headerRow.cost.value | multilingualCurrency }}
                </td>
            </tr>
        </table>
    </div>

    <div *ngIf="isTaxMaterialLaborRateExpanded">

        <div class="table-container margin-left-28">
            <table class="full-width">
                <tr class="table-row-container" *ngFor="let rowGroup of taxMaterialLaborRateFormArray.controls; let i = index; trackBy: trackByTaxMaterialLaborRateIndex" [formGroup]="rowGroup">
                    <td class="estimate-table-column width-190">
                        <span class="width-120">{{ rowGroup.controls.name.value | translate }}</span>
                        <mat-form-field class="no-padding-input mat-input-alignment width-70" appearance="outline">
                            <input matInput [appNumericMask]="solEstimateTableCommonFunctionsService.taxRateConfig" inputmode="decimal" formControlName="rate" class="input-alignment" />
                        </mat-form-field>
                    </td>
                    <td class="estimate-table-column width-70"></td>
                    <td class="estimate-table-column width-70"></td>
                    <td class="estimate-table-column width-70"></td>
                    <td class="estimate-table-column width-210 padding-gm"></td>
                    <td class="estimate-table-column width-110"></td>
                    <td class="estimate-table-column width-110">
                        {{ rowGroup.controls.cost.value | multilingualCurrency }}
                    </td>
                </tr>
            </table>
        </div>

    </div>
</div>
